// extracted by mini-css-extract-plugin
export default {"container":"character_container__QgKKg","img-container":"character_img-container__cZAUp","level-up-img":"character_level-up-img__+kQak"};